import React, { Component } from 'react';
import { Grid, Modal, Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import History from 'containers/common/history';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { accordianStyles } from 'components/accordian/accordian-styles';
import { combineStyles, getModalStyle } from 'services/utils/styles-service';
import AccordionHeader from 'components/form/header/accordion-header';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { numberToDollars } from 'services/utils/formatting';
import { convertToArborDate } from 'models/time/arbor-date';
import CopayCardDetail from '../../../tasks/fa/copay-card/copay-card-detail';
import { styles } from '../financials-styles';

class FinancialAssistanceCopayCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailsShown: props.financialAssistance.status === 1,
      editHistoryModalOpen: false,
    };
    this.toggleExpand = this.toggleExpand.bind(this);
    this.handleEditHistoryModal = this.handleEditHistoryModal.bind(this);
  }

  toggleExpand() {
    const { detailsShown } = this.state;

    this.setState({
      detailsShown: !detailsShown,
    });
  }

  handleEditHistoryModal(e) {
    e.stopPropagation();
    this.setState(prevState => ({
      editHistoryModalOpen: !prevState.editHistoryModalOpen,
    }));
  }

  render() {
    const { detailsShown, editHistoryModalOpen } = this.state;
    const { classes, financialAssistance, copayCardStatuses, therapies } = this.props;

    const accordionTitle = 'Copay Card'
      .concat(
        financialAssistance.therapy_id && therapies[financialAssistance.therapy_id]
          ? ` - ${therapies[financialAssistance.therapy_id].drug_name}`
          : '',
      )
      .concat(
        financialAssistance.expiration_date
          ? ` - Expires ${convertToArborDate(
              financialAssistance.expiration_date,
              true,
            ).getCustomerDate(true)}`
          : '',
      )
      .concat(
        financialAssistance.remaining_balance
          ? ` - Remaining Balance ${numberToDollars(financialAssistance.remaining_balance)}`
          : '',
      );

    return (
      <Accordion expanded={detailsShown} className={classes.accordianPanel}>
        <AccordionSummary
          classes={{
            expandIconWrapper: classes.expandIcon,
          }}
          onClick={this.toggleExpand}
          expandIcon={<ExpandMoreIcon />}
        >
          <AccordionHeader
            name={accordionTitle}
            historyHandler={this.handleEditHistoryModal}
            withHistory
            hideEdit
            updatedDt={financialAssistance.updated}
            updatedBy={financialAssistance.updated_by}
            id={`financial-assistance-${financialAssistance.id}`}
          />
          <Modal open={editHistoryModalOpen} onClose={this.handleEditHistoryModal}>
            <div style={getModalStyle()} className={classes.Modal}>
              <History
                // eslint-disable-next-line max-len
                url={`/patients/${financialAssistance.patient_id}/financials/patient-financial-assistance/${financialAssistance.id}`}
              />
            </div>
          </Modal>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container>
            <Grid item xs={12}>
              <CopayCardDetail
                type={
                  copayCardStatuses.find(
                    f => f.id === financialAssistance.financial_assistance_type,
                  ).sub_category
                }
                financialAssistance={financialAssistance}
                bin={financialAssistance.bin}
                pcn={financialAssistance.pcn}
                group={financialAssistance.group_id}
                phoneNumber={financialAssistance.phone_number}
                expDate={convertToArborDate(financialAssistance.expiration_date).getCustomerDate(
                  true,
                )}
                instructions={financialAssistance.instructions}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
}

const combinedStyles = combineStyles(styles, accordianStyles);

function mapStateToProps(state) {
  const { therapies } = state;
  return {
    therapies: therapies.data,
  };
}

export default compose(
  withStyles(combinedStyles),
  connect(mapStateToProps),
)(FinancialAssistanceCopayCard);
